import config from '@/config';
import apiClient from '@/api/client';
import ActivityLog from '@/api/resources/activityLog';
import AdvertisersResource from '@/api/resources/advertisers';
import AnalyticsResource from '@/api/resources/analytics';
import ApprovalsResource from '@/api/resources/approvals';
import BannersResource from '@/api/resources/banners';
import BannerFoldersResource from '@/api/resources/bannerFolders';
import CategoriesResource from '@/api/resources/categories';
import ExternalIntegrationsResource from '@/api/resources/external-integrations';
import ForeignLeadsCampaignsResource from '@/api/resources/foreignLeadsCampaigns';
import ConfigResource from '@/api/resources/config';
import DictResource from '@/api/resources/dict';
import EventTypes from '@/api/resources/eventTypes';
import EmailTemplates from '@/api/resources/emailTemplates';
import OffersResource from '@/api/resources/offers';
import OnboardingResource from '@/api/resources/onboarding';
import PartnersResource from '@/api/resources/partners';
import PostbacksResource from '@/api/resources/postbacks';
import Password from '@/api/resources/password';
import PayoutsResource from '@/api/resources/payouts';
import ProfileResource from '@/api/resources/profile';
import Proxies from '@/api/resources/proxies';
import SplitterResource from '@/api/resources/splitter';
import SubscriptionResource from '@/api/resources/subscription';
import TagsResource from '@/api/resources/tags';
import TasksResource from '@/api/resources/tasks';
import TriggersResource from '@/api/resources/triggers';
import TspResource from '@/api/resources/tsp';
import UsersResource from '@/api/resources/users';
import BlacklistResource from '@/api/resources/blacklist';
import ToolsResource from '@/api/resources/tools';
import SyncConfigurations from '@/api/resources/syncConfigurations';
import ItokensResource from '@/api/resources/itokens';
import SchedulesResource from '@/api/resources/schedules';
import ParametersResource from '@/api/resources/parameters';
import TrafficFilteringResource from '@/api/resources/trafficFiltering';
import BlacklistControlResource from '@/api/resources/blacklistControl';
import ApplicationsResource from '@/api/resources/applications';
import SKAdNetworkResource from '@/api/resources/skad';
import FraudProtectionResource from '@/api/resources/fraudProtection';
import TrafficControlResource from '@/api/resources/trafficControl';
import KPIControlResource from '@/api/resources/KPIControl';

class Api {
    config = ConfigResource;
    activityLog = ActivityLog;
    users = UsersResource;
    advertisers = AdvertisersResource;
    triggers = TriggersResource;
    banners = BannersResource;
    bannerFolders = BannerFoldersResource;
    categories = CategoriesResource;
    externalIntegrations = ExternalIntegrationsResource;
    foreignLeadsCampaigns = ForeignLeadsCampaignsResource;
    onboarding = OnboardingResource;
    splitter = SplitterResource;
    offers = OffersResource;
    partners = PartnersResource;
    postbacks = PostbacksResource;
    tsp = TspResource;
    approvals = ApprovalsResource;
    payouts = PayoutsResource;
    dicts = DictResource;
    analytics = AnalyticsResource;
    profile = ProfileResource;
    tags = TagsResource;
    tasks = TasksResource;
    password = Password;
    proxies = Proxies;
    emailTemplates = EmailTemplates;
    subscription = SubscriptionResource;
    eventTypes = EventTypes;
    blacklist = BlacklistResource;
    tools = ToolsResource;
    syncConfigurations = SyncConfigurations;
    itokens = ItokensResource;
    schedules = SchedulesResource;
    parameters = ParametersResource;
    trafficFiltering = TrafficFilteringResource;
    applications = ApplicationsResource;
    skad = SKAdNetworkResource;
    blacklistControl = BlacklistControlResource;
    fraudProtection = FraudProtectionResource;
    trafficControl = TrafficControlResource;
    kpiControl = KPIControlResource;

    constructor () {
        this.client = apiClient;
    }

    _mock (params) {
        return Promise.resolve(config.mock[params.path]);
    }

    getAgencies () {
        return this._mock({
            path: 'agency',
        });
    }

    socialAuthRedirect (provider) {
        return this.client.request({
            method: 'POST',
            path: `/oauth/${provider}/redirect`,
            data: { client_id: process.env.VUE_APP_CLIENT_ID },
        });
    }

    socialAuthCallback (provider, params) {
        return this.client.request({
            method: 'POST',
            path: `/oauth/${provider}/callback`,
            data: { client_id: process.env.VUE_APP_CLIENT_ID, ...params },
        });
    }

    login (credentials) {
        return this.client.request ({
            method: 'POST',
            path: '/oauth/token',
            data: { client_id: process.env.VUE_APP_CLIENT_ID, ...credentials },
        });
    }

    shadowLogin (payload) {
        return this.client.request ({
            method: 'POST',
            path: '/upyield/v1/shadow',
            data: payload,
        }, {
            ignoreUnauthorizedError: true,
        });
    }

    logout () {
        return this.client.request ({
            method: 'DELETE',
            path: '/oauth/token',
        });
    }

    getDicts () {
        return this.client.request ({
            method: 'GET',
            path: '/storage/dict.json',
            errorMessages: { 404: 'Could not load dictionaries' },
        });
    }

    errorLog (error) {
        return this.client.request({
            method: 'POST',
            path: '/public/v1/error-logs',
            data: { body: error },
        }, { showErrorMessages: false });
    }

}

export default new Api;
